(function () {
  'use strict';

  function getCartRoot() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }

    return '/';
  }

  function getCartAddUrl() {
    return getCartRoot() + 'cart/add.js';
  }

  function getCartObject() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  function dispatchCartUpdate(addResponse) {
    document.dispatchEvent(
      new CustomEvent('cart:updated', {
        bubbles: true,
        detail: { response: addResponse }
      })
    );

    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }

  function setButtonState(button, state, labels) {
    button.classList.remove('is-loading', 'is-success');

    if (state === 'loading') {
      button.classList.add('is-loading');
      button.disabled = true;
      button.textContent = labels.loading;
      return;
    }

    if (state === 'success') {
      button.classList.add('is-success');
      button.disabled = false;
      button.textContent = labels.success;
      window.setTimeout(function () {
        button.classList.remove('is-success');
        button.textContent = labels.defaultLabel;
      }, 1800);
      return;
    }

    if (state === 'error') {
      button.disabled = false;
      button.textContent = labels.error;
      window.setTimeout(function () {
        button.textContent = labels.defaultLabel;
      }, 1800);
      return;
    }

    button.disabled = false;
    button.textContent = labels.defaultLabel;
  }

  function handleAddToCart(button) {
    var variantId = button.dataset.variantId;
    var labels = {
      defaultLabel: button.dataset.labelDefault || '+ Add',
      loading: button.dataset.labelLoading || 'Adding...',
      success: button.dataset.labelSuccess || 'Added',
      error: button.dataset.labelError || 'Error'
    };

    if (!variantId) return;

    setButtonState(button, 'loading', labels);

    var cartObject = getCartObject();
    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);

    if (cartObject && typeof cartObject.getSectionsToRender === 'function') {
      formData.append(
        'sections',
        cartObject.getSectionsToRender().map(function (section) {
          return section.id;
        }).join(',')
      );
    } else {
      formData.append('sections', 'cart-drawer,cart-icon-bubble');
    }

    formData.append('sections_url', window.location.pathname);

    fetch(getCartAddUrl(), {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: formData
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (addResponse) {
        if (addResponse.status) {
          throw addResponse;
        }

        if (cartObject) {
          cartObject.classList.remove('is-empty');

          if (typeof cartObject.renderContents === 'function') {
            cartObject.renderContents(addResponse);
          }
        }

        dispatchCartUpdate(addResponse);
        setButtonState(button, 'success', labels);
      })
      .catch(function () {
        setButtonState(button, 'error', labels);
      });
  }

  function initCompleteTheLook(section) {
    if (section.dataset.ctlInitialized === 'true') return;
    section.dataset.ctlInitialized = 'true';

    section.addEventListener('click', function (event) {
      var button = event.target.closest('[data-ctl-add]');
      if (!button || !section.contains(button)) return;

      event.preventDefault();
      handleAddToCart(button);
    });
  }

  function initAll() {
    document.querySelectorAll('[data-complete-the-look]').forEach(initCompleteTheLook);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-complete-the-look]') || event.target;
    if (section.matches && section.matches('[data-complete-the-look]')) {
      initCompleteTheLook(section);
    }
  });
})();
